import { decorate, observable } from 'mobx';

import Cookies from 'js-cookie';
import React from 'react';

import { Steps, SplitType, GuidEmpty } from '../lib/constants';
import { logClientEvent } from '../helpers/ClientLog';

const MILLISECONDS_PER_HOUR = 60 * 60 * 1000;
const HYDRATION_EXPIRY = 4 * MILLISECONDS_PER_HOUR;

class PaymentProcess extends React.Component {
  constructor() {
    super()
    this.activeStep = Steps.DEFAULT;
    this.previousSteps = [];
    this.postRegisterAction = () => { };
    this.bufferedAction = () => { };
    this.restaurantSearchCache = {};
    this.restaurant = null;
    this.tableNumber = 0;
    this.selectedSplitIndex = null;
    this.bill = null;
    this.billTotal = 0;
    this.billTotalWhenPaying = 0;
    this.discountTotal = 0;
    this.gratuityTotal = 0;
    this.grandTotal = 0;
    this.paymentFailed = false;
    this.paymentFailReason = null;
    this.paymentLoadingAnimation = false;
    this.submittingPayment = false;
    this.paymentTimers = [];
    this.customer = null;
    this.mainCTAActive = false;
    this.mainCTAText = null;
    this.secondaryCTAActive = false;
    this.secondaryCTAText = '';
    this.errorModalEnabled = false;
    this.errorModalMessage = null;
    this.errorModalDisableTimeout = null;
    this.errorModalMessageClearTimeout = null;
    this.isRegistered = false;
    this.modalActive = null;
    this.modalTitle = '';
    this.modalMessage = '';
    this.modalVoucherCode = '';
    this.modalMainCTAText = '';
    this.modalSecondaryCTAText = '';
    this.cachedEmailAddress = '';
    this.socialCustomer = null;
    this.mainCTALoadingAnimationActive = false;
    this.secondaryCTALoadingAnimationActive = false;
    this.privacyPolicyAndTermsConditionsModal = null;
    this.privacyPolicyAndTermsConditionsModalMenu = null;
    this.termAndConditionsCopy = false;
    this.termAndConditionsMenuCopy = false;
    this.cookiesPolicyCopy = false;
    this.privacyPolicyCopy = false;
    this.splitBillSessionToken = null;
    this.assignedSplitIndex = null;
    this.sourceIsApp = false;
    this.appPlatform = null;
    this.externalConfig = null;
    this.refreshButtonLoading = false;
    this.optingInAtCheckout = false;
    this.optedOutAtCheckout = false;
    this.isOrderJourney = false;
    this.isCheckInJourney = false;
    this.dataCaptureStatus = {};
    this.brandTermConditions = false;
    this.culture = {
      symbol: "",
      language: "",
      currency: ""
    };
    this.canSignup = true;
    this.hasSocialLinks = true;
    this.companyName = "PizzaExpress";
    this.returnHref = "http://www.pizzaexpress.com";
    this.cookiesAccepted = false;
    this.homePageImage = "PE_Truant_Updated_Homepage.jpg";
    this.applySoftOptIn = true;
    this.swipeableModalPosition = '-100%';
    this.swipeable = false;
    this.slideOutAnimation = false;
    this.digitalMenuOffsetHeight = null;
    this.appFooterHeight = null;
    this.restaurantUrl = '';
    this.appHeaderHeight = null;
    this.isLocalMenuFirstLoaded = false;
  }

  mainCTA() {
    return;
  };

  secondaryCTA() {
    return;
  };

  mainModalCTA() {
    return;
  };

  setMainModalCTA(callback) {
    this.mainModalCTA = callback;
  };

  setupMainModal({ title, voucherCode, message, mainCTAText, secondaryCTAText }) {
    this.modalTitle = title || null;
    this.modalVoucherCode = voucherCode || null;
    this.modalMessage = message || null;
    this.modalMainCTAText = mainCTAText;
    this.modalSecondaryCTAText = secondaryCTAText;
  }

  enableMainModal() {
    this.modalActive = true;
  }

  disableMainModal() {
    this.modalActive = false;
    this.closeSlideUpModal();
  }

  setSelectedSplitIndex(selectedSplitIndex) {
    this.selectedSplitIndex = selectedSplitIndex;
    if (selectedSplitIndex === null) {
      this.setBillTotal(this.bill[0].outstandingBalance);
      this.setDiscountTotal(this.bill[0].totalDiscounts);
    } else {
      this.updateBillTotalAndSplit();
    }
    if (this.activeStep === Steps.BILL) {
      this.updateBillCTAs();
    }
  }

  setBill(bills) {
    this.bill = bills;

    this.updateBillTotalAndSplit();
    this.setGrandTotal();

    if (this.activeStep === Steps.BILL) {
      this.updateBillCTAs();
    }
  }

  updateBillTotalAndSplit() {
    let splits = !!this.bill[0].splitBill
      ? this.bill[0].splitBill.splits
      : null;
    let numberOfSplits = splits.length;

    if (
      numberOfSplits > 0 &&
      this.selectedSplitIndex !== null &&
      !!splits[this.selectedSplitIndex] &&
      this.bill[0].splitBill.splitType !== SplitType.None
    ) {
      if (splits[this.selectedSplitIndex].paid === true) {
        this.setBillTotal(0);
      } else {
        var splitBalance = splits[this.selectedSplitIndex].amount;
        this.setBillTotal(splitBalance);
      }
      var discountTotal = splits[this.selectedSplitIndex].discountAmount;
      this.setDiscountTotal(discountTotal)
    } else {
      this.selectedSplitIndex = null;
      this.setBillTotal(this.bill[0].outstandingBalance);
      this.setDiscountTotal(this.bill[0].totalDiscounts)
    }

    if (this.bill[0].splitBill.splitType === SplitType.None) {
      this.assignedSplitIndex = null;
    }
  }

  setDiscountTotal(value) {
    this.discountTotal = value;
  }

  setBillTotal(value) {
    this.billTotal = value;
  }

  setGratuityTotal(value) {
    this.gratuityTotal = value;
  }

  setGrandTotal() {
    this.grandTotal = (
      parseFloat(this.billTotal) + parseFloat(this.gratuityTotal)
    ).toFixed(2);
  }

  clearPreviousSteps() {
    this.previousSteps = [];
  }

  goToStep(step) {
    if (!(step >= 0)) throw new Error(`goToStep was passed invalid parameter (${step}) in PaymentProcess`)

    this.mainCTAActive = false;
    this.previousSteps.push(this.activeStep);
    this.activeStep = step;
  }

  goToStepWithoutHistory(step) {
    this.mainCTAActive = false;
    this.activeStep = step;
  }

  setBufferedAction(bufferedAction) {
    this.bufferedAction = bufferedAction;
  }

  useBufferedAction() {
    if (this.bufferedAction !== null) {
      this.bufferedAction();
      this.bufferedAction = null;
    }
  }

  setPostRegisterAction(postRegisterAction) {
    this.postRegisterAction = postRegisterAction;
  }

  usePostRegisterAction() {
    if (this.postRegisterAction !== null) {
      this.postRegisterAction();
      this.postRegisterAction = null;
    }
  }

  popStep() {
    this.mainCTAActive = false;
    if (this.previousSteps.length > 0) {
      this.activeStep = this.previousSteps.pop();
    }
  }

  resetToBillStepPayAtTable() {
    this.activeStep = Steps.BILL;
    this.previousSteps = [
      Steps.HOME,
      Steps.RESTAURANT_SEARCH,
      Steps.TABLE_PICKER
    ];
  }

  selectRestaurant(restaurant) {
    if (restaurant !== this.restaurant) {
      this.tableNumber = 0;
    }
    if (restaurant) {
      this.restaurant = restaurant;
    }
  }

  cacheRestaurantSearch(data) {
    if (data) {
      this.restaurantSearchCache = data;
    }
  }

  selectTableNumber(tableNumber) {
    if (tableNumber) {
      this.tableNumber = tableNumber;
    }
  }  

  startRefreshBillCycle() {
    var time = 2.5;
    if (
      this.activeStep >= Steps.BILL &&
      this.activeStep <= Steps.PAY &&
      this.submittingPayment !== true &&
      !!this.restaurant &&
      !!this.restaurant.id &&
      !!this.tableNumber &&
      !!this.bill && this.bill[0]
    ) {
      fetch(`api/Bill/LookupCache/${this.bill[0].providerId}/${this.restaurant.id}/${this.tableNumber}`)
        .then(response => {
          if (response.status === 200) {
            return response
              .json()
              .catch(err => {
                return null;
              })
              .then(data => {
                let bills = data.bills;

                if (!!bills && bills.length > 0) {
                  this.setBill(bills);

                  setTimeout(() => this.startRefreshBillCycle(), time * 1000);
                } else {
                  this.popStep();
                  this.setErrorModalMessage('Bill no longer available');
                }
              });
          }
        })
        .catch(err => {
          setTimeout(() => this.startRefreshBillCycle(), (time * 3) * 1000);
        });
    }
  }

  startBillPageOnlyRecycle() {  
    var time = 30;
    if (
      this.activeStep == Steps.BILL && 
      !!this.restaurant &&
      !!this.restaurant.id &&
      !!this.tableNumber &&
      !!this.bill && this.bill[0]
    ) {
      fetch(`api/Bill/LookupCache/${this.bill[0].providerId}/${this.restaurant.id}/${this.tableNumber}`)
        .then(response => {
          if (response.status === 200) {
            return response
              .json()
              .catch(err => {
                return null;
              })
              .then(data => {
                let bills = data.bills;

                if (!!bills && bills.length > 0) {
                  this.setBill(bills);

                  setTimeout(() => this.startBillPageOnlyRecycle(), time * 1000);
                } else {
                  this.popStep();
                  this.setErrorModalMessage('Bill no longer available');
                }
              });
          }
        })
        .catch(err => {
          setTimeout(() => this.startBillPageOnlyRecycle(), (time * 3) * 1000);
        });
    }
  }

  paymentSuccessful(data) {
    this.clearPaymentTimers();
    var paymentResponse = data.payment;
    if (
      paymentResponse.billPaid.paymentStatus === 2 ||
      (paymentResponse.billPaid.paymentStatus === 1 &&
        paymentResponse.billPaid.splitBill.splits.length > 0)
    ) {
      this.billTotalWhenPaying = this.billTotal;

      let bill = this.bill;
      bill[0] = paymentResponse.billPaid;
      this.setBill(bill);

      this.previousSteps = [];
      this.isRegistered = !!data.isRegistered && data.isRegistered;
      this.activeStep = Steps.PAYMENT_CONFIRMATION;
      this.setAssignedSplitIndex(null);
      this.setSelectedSplitIndex(null);
    } else {
      this.setErrorModalMessage(
        'Your payment was successful, but your bill has not been completely settled'
      );
      let bill = this.bill;
      bill[0] = paymentResponse.billPaid;
      this.setBill(bill);
      while (this.activeStep !== Steps.BILL) {
        this.popStep();
      }
      this.startRefreshBillCycle();
    }

    this.submittingPayment = false;
  }

  submitPayment() {
    this.submittingPayment = true;
    this.paymentFailed = false;
    this.paymentFailReason = null;
    this.paymentLoadingAnimation = true;
    this.mainCTAActive = false;
    this.startPaymentTimers();
  }

  submitPaymentFail(reason = null) {
    this.clearPaymentTimers();
    logClientEvent('Payment failed', {
      Reason: reason,
      RestaurantId: !!this.restaurant ? `${this.restaurant.id}` : '',
      TableNumber: `${this.tableNumber}`,
      ProviderId: !!this.bill && !!this.bill[0] ? `${this.bill[0].providerId}` : '',
      GrandTotal: `${this.grandTotal}`
    });
    this.submittingPayment = false;
    this.paymentFailed = true;
    this.paymentFailReason = reason;
    this.paymentLoadingAnimation = false;
    this.mainCTAActive = true;
    this.startRefreshBillCycle();
  }

  submitPaymentCancel() {
    this.clearPaymentTimers();
    this.submittingPayment = false;
    this.mainCTAActive = true;
  }

  startPaymentTimers() {
    this.clearPaymentTimers();

    var getContext = () => ({
      RestaurantId: !!this.restaurant ? `${this.restaurant.id}` : '',
      TableNumber: `${this.tableNumber}`,
      ProviderId: !!this.bill && !!this.bill[0] ? `${this.bill[0].providerId}` : '',
      GrandTotal: `${this.grandTotal}`
    });

    var elapsedSeconds = 0;
    var interval = setInterval(() => {
      elapsedSeconds += 10;
      logClientEvent(`Payment pending - exceeded ${elapsedSeconds}s`, {
        ...getContext(),
        ElapsedSeconds: `${elapsedSeconds}`
      });
    }, 10 * 1000);
    this.paymentTimers.push(interval);
  }

  clearPaymentTimers() {
    if (!!this.paymentTimers) {
      this.paymentTimers.forEach(timer => window.clearInterval(timer));
    }
    this.paymentTimers = [];
  }

  startedLoadingPaymentForm() {
    this.paymentLoadingAnimation = true;
    this.paymentFailed = false;
    this.paymentFailReason = null;
  }

  pausePaymentLoadingAnimation() {
    this.paymentLoadingAnimation = false;
  }

  unpausePaymentLoadingAnimation() {
    this.paymentLoadingAnimation = true;
  }

  finishedPaymentLoadingAnimation() {
    this.paymentLoadingAnimation = false;
  }

  startMainCTALoadingAnimation() {
    this.mainCTALoadingAnimationActive = true;
  }

  stopMainCTALoadingAnimation() {
    this.mainCTALoadingAnimationActive = false;
  }

  startSecondaryCTALoadingAnimation() {
    this.secondaryCTALoadingAnimationActive = true;
  }

  stopSecondaryCTALoadingAnimation() {
    this.secondaryCTALoadingAnimationActive = false;
  }

  termAndConditionsModal() {
    this.privacyPolicyAndTermsConditionsModal = true;
    this.termAndConditionsCopy = true;
  }

  privacyPolicyModal() {
    this.privacyPolicyAndTermsConditionsModal = true;
    this.privacyPolicyCopy = true;
  }

  termAndConditionsWebModalMenu() {
    this.privacyPolicyAndTermsConditionsModalMenu = true;
    this.termAndConditionsCopy = true;
  }

  privacyPolicyWebModalMenu() {
    this.privacyPolicyAndTermsConditionsModalMenu = true;
    this.privacyPolicyCopy = true;
  }

  termAndConditionsModalMenu() {
    this.privacyPolicyAndTermsConditionsModalMenu = true;
    this.termAndConditionsMenuCopy = true;
  }

  cookiePolicyModal() {
    this.privacyPolicyAndTermsConditionsModalMenu = true;
    this.cookiesPolicyCopy = true;
  }

  hasAcceptedCookies() {
    let acceptCookie = Cookies.get('PAT_ACCEPT_COOKIES');
    if (!!acceptCookie) {
      return acceptCookie == 'true';
    }
    else {
      return false;
    }
  }

  loginAsGuest() {
    this.customer = null;
  }

  loginAsCustomer(data) {
    const {
      customerSessionToken: {
        pizzaExpressId,
        emailAddress,
        token
      },
      title,
      firstName,
      lastName,
      vaultId,
      emailOptIn,
      favouriteRestaurants
    } = data;

    this.setOptingInAtCheckout(false);
    this.setOptedOutAtCheckout(false);
    this.customer = {
      id: pizzaExpressId,
      vaultId: vaultId,
      emailOptIn: emailOptIn,
      emailAddress: emailAddress,
      token: token,
      title: title,
      firstName: firstName,
      lastName: lastName,
      favouriteRestaurants: favouriteRestaurants,
    };
  }

  setCustomer({
    id,
    title,
    firstName,
    lastName,
    emailAddress,
    emailOptIn,
    vaultId,
    token,
    favouriteRestaurants
  }) {
    this.setOptingInAtCheckout(false);
    this.setOptedOutAtCheckout(false);
    this.customer = {
      id,
      title,
      firstName,
      lastName,
      emailAddress,
      emailOptIn,
      vaultId,
      token,
      favouriteRestaurants,
    };
  }


  logout() {
    this.customer = null;
    Cookies.remove('USER_SESSION_TOKEN', { domain: '.pizzaexpress.com' });
    Cookies.remove('UAT_USER_SESSION_TOKEN', { domain: '.pizzaexpress.com' });
  }

  setMainCTA(callback) {
    this.mainCTA = callback;
    this.mainCTAActive = true;
  };

  setMainCTAText(value) {
    this.mainCTAText = value;
  };

  setSecondaryCTA(callback) {
    this.secondaryCTA = callback;
    this.enableSecondaryCTA();
  };

  setSecondaryCTAText(text) {
    this.secondaryCTAText = text;
  };

  enableMainCTA() {
    this.mainCTAActive = true;
  };

  disableMainCTA() {
    this.mainCTAActive = false;
  };

  enableSecondaryCTA() {
    this.secondaryCTAActive = true;
  };

  disableSecondaryCTA() {
    this.secondaryCTAActive = false;
  };

  setGratuitySliderValue(value) {
    this.gratuitySliderValue = value;
  }

  setErrorModalMessage(message) {
    this.errorModalEnabled = true;
    this.errorModalMessage = message;
    if (!!this.errorModalDisableTimeout) {
      window.clearTimeout(this.errorModalDisableTimeout);
    }
    if (!!this.errorModalMessageClearTimeout) {
      window.clearTimeout(this.errorModalMessageClearTimeout);
    }

    this.errorModalDisableTimeout = setTimeout(() => {
      this.disableErrorModal();
    }, 10 * 1000);
  }

  disableErrorModal() {
    if (!!this.errorModalDisableTimeout) {
      window.clearTimeout(this.errorModalDisableTimeout);
    }
    if (!!this.errorModalMessageClearTimeout) {
      window.clearTimeout(this.errorModalMessageClearTimeout);
    }
    setTimeout(() => {
      this.errorModalEnabled = false;
      this.errorModalMessageClearTimeout = setTimeout(
        () => (this.errorModalMessage = null),
        1.1 * 1000
      );
      this.clearSlideUpModalContents();
    }, 300)
  }

  storeVaultId(vaultId) {
    this.customer.vaultId = vaultId;
  }

  storeCustomerEmail(emailAddress) {
    if (this.customer == null || (!!this.customer && !this.customer.id)) {
      this.customer = {
        emailAddress
      };
    }
  }

  generatePaymentBody(
    payload,
    emailAddress = null,
    storeInVault = false
  ) {

    //there are two types of optin journey soft opt in which askes to optout and the original which asks to opt in

    var isOptedIn = this.applySoftOptIn ? !this.optedOutAtCheckout : this.optingInAtCheckout;

    const result = JSON.stringify({
      PaymentMethodNonce: payload.nonce,
      Bill: this.bill[0],
      ProviderId: this.bill[0]?.providerId,
      GrandTotal: this.grandTotal,
      BillTotal: this.billTotal,
      GratuityTotal: this.gratuityTotal,
      Customer:
        !!this.customer && !!this.customer.id && !!this.customer.emailAddress
          ? this.customer
          : { emailAddress },
      VaultId: !!this.customer?.vaultId || null,
      Restaurant: this.restaurant,
      StoreCardInVault: storeInVault,
      SplitIndex: this.selectedSplitIndex,
      OptIn: isOptedIn,
      MerchantAccountId: 'PizzaExpressMobile', // TODO(john): Put in restaurant object
      SourceIsApp: this.sourceIsApp,
      LoggedIn: !!this.customer && !!this.customer.id && !!this.customer.emailAddress,
      TableNumber: this.tableNumber
    });
    return result;
  }

  setCachedEmailAddress(emailAddress) {
    this.cachedEmailAddress = emailAddress;
  }

  resetIsRegistered() {
    this.isRegistered = false;
  }

  setIsRegistered() {
    this.isRegistered = true;
  }

  setSocialCustomer(profile) {
    this.socialCustomer = profile;
  }

  setSplitBillSessionToken(value) {
    this.splitBillSessionToken = value;
  }

  setAssignedSplitIndex(value) {
    this.assignedSplitIndex = value;
  }

  async refreshTable(updateLoadingAnimation = true) {
    if (updateLoadingAnimation) this.startRefreshButtonLoading();
    if (this.restaurant == null || this.bill == null) {
      return;
    }

    let restaurantId = this.restaurant.id;
    let tableNumber = this.tableNumber;
    let providerId = this.bill[0].providerId;
    let response = await fetch(`api/Bill/RefreshTable/${providerId}/${restaurantId}/${tableNumber}`);
    if (response.status === 200) {
      let data;
      try {
        data = await response.json();
      } catch (err) {
        console.error(err);
      }

      const { success, bills } = data;
      if (success === true) {
        this.setBill(bills);
      }
    }
    if (updateLoadingAnimation) this.stopRefreshButtonLoading();
  }

  updateBillCTAs() {
    if (this.billTotal > 0) {
      this.enableMainCTA();
    } else {
      this.disableMainCTA();
    }

    this.stopRefreshButtonLoading();
    let mainCTAActive =
      !!this.bill && !!this.bill[0] && this.bill[0].outstandingBalance > 0;
    if (mainCTAActive === true) {
      let bill = this.bill[0];

      let splitBillOpen =
        !!bill.splitBill &&
        !!bill.splitBill.splits &&
        bill.splitBill.splitType !== SplitType.None;

      if (splitBillOpen) {
        let splitBill = bill.splitBill;
        if (bill.payments.length > 0) {
          this.setSecondaryCTA(() =>
            this.setErrorModalMessage(
              'You cannot cancel a split bill once payments have been made.'
            )
          );
          this.disableSecondaryCTA();
        } else {
          this.setSecondaryCTA(() => this.openCancelSplitModal());
        }
        this.setSecondaryCTAText('Cancel Split');

        if (this.selectedSplitIndex === null) {
          if (this.assignedSplitIndex === null) {
            this.setMainCTAText('Join split bill');
            if (
              bill.splitBill.splitType === SplitType.SplitByItem ||
              bill.splitBill.splits.some(s => s.sessionToken === GuidEmpty)
            ) {
              this.setMainCTA(() => this.goToStep(Steps.SPLIT_BILL_NAME));
            } else {
              this.setMainCTA(() =>
                this.setErrorModalMessage('All splits have been assigned')
              );
              this.disableMainCTA();
            }
          } else {
            this.setMainCTAText('Go to my bill');
            this.setMainCTA(() => this.setSelectedSplitIndex(this.assignedSplitIndex));
          }
        } else {
          if (this.billTotal > 0) {
            if (this.selectedSplitIndex !== this.assignedSplitIndex) {
              this.setMainCTA(this.openPayOtherSplitModal);
            } else {
              this.setMainCTA(this.checkoutButtonHandler);
            }
            this.setMainCTAText(this.getCheckoutCTAText());
          } else if (
            splitBill.splitType === SplitType.SplitByItem &&
            splitBill.splits[this.selectedSplitIndex].paid === false
          ) {
            this.setMainCTAText('No items selected.');
          } else {
            this.setMainCTAText('Payment complete.');
          }
        }
      } else {
        this.setSecondaryCTA(this.splitBillMenuButtonHandler);
        this.setMainCTAText(this.getCheckoutCTAText());
        this.setMainCTA(this.checkoutButtonHandler);
        this.setSecondaryCTAText('Split Bill');
        this.enableSecondaryCTA();
      }
    } else {
      this.disableSecondaryCTA();
    }
  }

  openPayOtherSplitModal() {
    this.modalActive = true;
    this.modalTitle = 'Pay other split';
    this.modalMessage =
      "You are about to pay for someone else's split. Are you sure you want to proceed?";
    this.modalMainCTAText = 'Yes';
    this.modalSecondaryCTAText = 'No';
    this.setMainModalCTA(this.checkoutButtonHandler);
  }

  showEatOutToHelpOutPage() {
    const { providerValues } = this.bill[0];
    var eatOutToHelpOutEnabled = providerValues["EatOutToHelpOutEnabled"] === 'True';
    if (!eatOutToHelpOutEnabled) {
      return false;
    }

    var eatOutToHelpOutDiscountFound = providerValues["EatOutToHelpOutDiscountFound"] === 'True';
    if (eatOutToHelpOutDiscountFound) {
      return false;
    }

    return true;
  }

  checkoutButtonHandler() {
    if (this.showEatOutToHelpOutPage()) {
      this.setBufferedAction(() => this.popStep())
      this.goToStep(Steps.CONTENT_PAGE);
    } else {
      this.goToStep(Steps.APPLY_GRATUITY)
    }
  }

  splitBillMenuButtonHandler() {
    if (this.showEatOutToHelpOutPage()) {
      this.setBufferedAction(() => this.popStep())
      this.goToStep(Steps.CONTENT_PAGE);
    } else {
      this.goToStep(Steps.SPLIT_BILL_MENU)
    }
  }

  openCancelSplitModal() {
    this.modalActive = true;
    this.modalTitle = 'Cancel Split';
    this.modalMessage =
      'This will remove all split bills on your table. Are you sure you want to proceed?';
    this.modalMainCTAText = 'Yes';
    this.modalSecondaryCTAText = 'No';
    const deleteCardCallback = () => {
      fetch(
        `api/Bill/CancelSplitBill/${this.bill[0].providerId}/${this.restaurant.id}/${this.tableNumber}/`
      )
        .then(response => response.json())
        .catch(err => {
          console.error(err);
        })
        .then(data => {
          if (!!data && data.success === true) {
            this.setBill(data.bills);
          } else {
            this.setErrorModalMessage(data.reason);
          }
        });
    };
    this.setMainModalCTA(deleteCardCallback);
  }

  getCheckoutCTAText() {
    var text = `Checkout ${this.getCurrency().symbol + parseFloat(this.billTotal).toFixed(2)}`;
    return text;
  }

  setSourceIsAppTrue() {
    this.sourceIsApp = true;
  }

  setAppPlatform(platform) {
    this.appPlatform = platform;
  }

  useSetup(data) {
    this.externalConfig = data;
  }

  startRefreshButtonLoading() {
    this.refreshButtonLoading = true;
  }

  stopRefreshButtonLoading() {
    this.refreshButtonLoading = false;
  }

  setOptingInAtCheckout(value) {
    this.optingInAtCheckout = value;
  }
  setOptedOutAtCheckout(value) {
    this.optedOutAtCheckout = value;
  }

  setIsOrderJourney(value) {
    this.isOrderJourney = value;
  }
  setRestaurantUrl(value){
    this.restaurantUrl = value;
  }
  setIsCheckInJourney(value) {
    this.isCheckInJourney = value;
  }


  getBasket() {
    const baskets = localStorage.getItem('baskets');
    if (!baskets) return [];

    const data = JSON.parse(baskets)[this.restaurant.id];
    if (!data) return [];

    const { basket, updated } = data;
    if ((Date.now() - updated) > 172800000) return [];

    return basket;
  }

  setBasket(value) {
    const data = { basket: value, updated: Date.now() }
    let baskets = localStorage.getItem('baskets');
    if (!baskets) baskets = {}
    else baskets = JSON.parse(baskets);
    baskets[this.restaurant.id] = data;
    localStorage.setItem('baskets', JSON.stringify(baskets));
  }

  setDataCaptureStatusForCurrentRestaurant(value) {
    const data = { status: value, updated: Date.now() }
    const localItem = localStorage.getItem('trackTrace');

    let dataCaptureStatus = {};
    if (!!localItem) dataCaptureStatus = JSON.parse(localItem);

    dataCaptureStatus[this.restaurant.id] = data;

    localStorage.setItem('trackTrace', JSON.stringify(dataCaptureStatus));
  }

  getDataCaptureStatusForCurrentRestaurant() {
    if (this.isCheckInJourney) {
      const localItem = localStorage.getItem('trackTrace');
      if (!localItem) return null;

      const data = JSON.parse(localItem)[this.restaurant.id];
      if (!data) return null;

      const { status, updated } = data;
      if ((Date.now() - updated) > HYDRATION_EXPIRY) return null;

      return status;
    }

    return false;
  }

  setCurrency(data) {
    this.culture = data;
  }
  getCurrency() {
    return this.culture;
  }
  setCanSignup(value) {
    this.canSignup = value
  }
  getCanSignup() {
    return this.canSignup;
  }
  setHasSocialLinks(value) {
    this.hasSocialLinks = value
  }
  getHasSocialLinks() {
    return this.hasSocialLinks;
  }
  setComanyName(value) {
    this.companyName = value
  }
  getCompanyName() {
    return this.companyName;
  }
  setApplySoftOtIn(value) {
    this.applySoftOptIn = value
  }
  getApplySoftOptIn() {
    return this.applySoftOptIn;
  }
  setReturnHref(value) {
    this.returnHref = value
  }
  getReturnHref() {
    return this.returnHref;
  }
  getHomePageImage() {
    return this.homePageImage;
  }
  clearSlideUpModalContents() {
    this.slideModalTitleBackground = '';
    this.slideModalHeaderTitle = null;
    this.slideModalHeaderText = null;
    this.slideModalTitle = '';
    this.slideModalIconBtn = false;
    this.slideModalSecondaryCTAText = '';
    this.disableSecondaryModalCta = false;
    this.slideModalPrimaryCTAText = '';
    this.slideUpModalTable = null;
    this.slideUpModalWaiterMessage = false;
    this.slideModalBtnColumn = false;
    this.slideModalBtnColumnCustomClasses = '';
    this.slideOutAnimation = false;
    this.swipeableModalPosition = '-100%';
    this.modalMessage = '';
  }

  closeSlideUpModal() {
    this.slideOutAnimation = true;
    setTimeout(() => {
      this.slideUpModal = false;
      this.clearSlideUpModalContents();
    }, 300)
  }

  setSwipeable(value) {
    this.swipeable = value;
  }

  setDragDownModal(value) {
    this.swipeableModalPosition = value;
  }

  setDigitalMenuOffset(value) {
    this.digitalMenuOffsetHeight = value
  }

  setAppFooterHeight(value) {
    this.appFooterHeight = value
  }

  setAppHeaderHeight(value) {
    this.appHeaderHeight = value
    }

  firstLoadLocalMenu(value){
      this.isLocalMenuFirstLoaded = value;
    }

    closePrivacyPolicyTermsAndConditionsModal() {
      this.slideOutAnimation = true;      
      setTimeout(() => {
        this.privacyPolicyAndTermsConditionsModalMenu = null;
        this.privacyPolicyAndTermsConditionsModal = null;
        this.termAndConditionsMenuCopy = false;
        this.termAndConditionsCopy = false;
        this.privacyPolicyCopy = false;
        this.cookiesPolicyCopy = false;
        this.slideUpModal = false;
        this.clearSlideUpModalContents();
      }, 300);
    }

}

decorate(PaymentProcess, {
  isLocalMenuFirstLoaded: observable,
  activeStep: observable,
  customer: observable,
  grandTotal: observable,
  previousSteps: observable,
  footerStub: observable,
  billTotal: observable,
  discountTotal: observable,
  gratuityTotal: observable,
  paymentLoadingAnimation: observable,
  selectedSplitIndex: observable,
  bill: observable,
  mainCTAActive: observable,
  mainCTAText: observable,
  mainCTA: observable,
  secondaryCTAActive: observable,
  secondaryCTAText: observable,
  secondaryCTALoading: observable,
  errorModalMessage: observable,
  errorModalEnabled: observable,
  submittingPayment: observable,
  paymentFailed: observable,
  paymentFailReason: observable,
  isRegistered: observable,
  modalActive: observable,
  modalTitle: observable,
  modalMessage: observable,
  modalVoucherCode: observable,
  modalMainCTAText: observable,
  modalSecondaryCTAText: observable,
  mainCTALoadingAnimationActive: observable,
  secondaryCTALoadingAnimationActive: observable,
  privacyPolicyAndTermsConditionsModal: observable,
  privacyPolicyAndTermsConditionsModalMenu: observable,
  cookiesAccepted: observable,
  splitBillSessionToken: observable,
  assignedSplitIndex: observable,
  refreshButtonLoading: observable,
  isOrderJourney: observable,
  restaurant: observable,
  restaurantUrl: observable,
  isCheckInJourney: observable,
  setComanyName: observable,
  setApplySoftOtIn: observable,
  setDigitalMenuOffset: observable,
  digitalMenuOffsetHeight: observable,
  swipeableModalPosition: observable,
  setAppFooterHeight: observable,
  appFooterHeight: observable,
  setAppHeaderHeight: observable,
  appHeaderHeight: observable,
  setRestaurantUrl: observable,
  firstLoadLocalMenu: observable
});

export default new PaymentProcess();
